import { Helmet } from '@dr.pogodin/react-helmet';
import Loading from '../common/lib/Loading';
import useJson from '../common/lib/useJson';
import XoopsCode from '../common/lib/XoopsCode';
import type { MultiLang } from '../config';
import Functions from '../functions';

interface Props {
    lang: MultiLang;
}

interface BulletinPost {
    id: number;
    author: string;
    post_date: number;
    end_date: number;
    tags: string[];
    text: Record<MultiLang, string>;
}

const NimgdocsBulletinLog = (props: Props) => {
    const { lang } = props;
    const bulletin = useJson<BulletinPost[]>('/modules/nimgdocs/bulletin.json');
    const title = Functions.mlang('[en]Expired Posts[/en][ja]掲載期間の終了した投稿[/ja]', lang);
    if (typeof bulletin === 'undefined') {
        return <Loading />;
    }
    const now = Date.now() / 1000;
    const logs = (bulletin ?? []).filter((log) => log.end_date < now && log.text[lang] !== '');
    return (
        <>
            <Helmet>
                <title>
                    {title} - NIMG Documents - {Functions.siteTitle(lang)}
                </title>
            </Helmet>
            <h1>{title}</h1>
            {logs.map((log) => (
                <div key={log.id}>
                    {log.tags.map((tag) => (
                        <span
                            key={tag}
                            style={{ margin: '0 2px', padding: '0 2px', color: '#666', backgroundColor: '#eee' }}
                        >
                            {tag}
                        </span>
                    ))}
                    <XoopsCode lang={lang} text={log.text[lang]} dobr />
                    <div style={{ margin: '5px 0', textAlign: 'right' }}>
                        {Functions.formatDate(log.post_date, 'yyyy-MM-dd HH:mm:ss')} Posted by <b>{log.author}</b>
                    </div>
                    <hr style={{ margin: '10px 0', border: 'none', borderTop: '1px dotted #ccc' }} />
                </div>
            ))}
        </>
    );
};

export default NimgdocsBulletinLog;
